import React from "react";
import Typography from "style-guide/component/Typography";

interface GradientProps {
  children: React.ReactNode;
}

const Gradient: React.FC<GradientProps> = ({ children }) => {
  return (
    <div
      className="min-h-screen w-full flex flex-col items-center justify-center relative overflow-hidden"
      style={{
        background: `
          radial-gradient(ellipse 85% 75% at center 0%, 
            #000000 36%,
            #0F428D 64%,
            #487AC4 80%,
            #6A9DD7 90%,
            #ffffff 110% 
          )`,
      }}
    >
      <div className="absolute top-2 xl:top-5">
        <Typography
          variant="Heading 3"
          text="Nozma"
          className="text-white font-bold"
        />
      </div>
      <div className="px-2 sm:px-0 mt-12 xl:mt-5">{children}</div>
    </div>
  );
};

export default Gradient;
